import React, { useState, useEffect } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Modal, Button, Form } from 'react-bootstrap';
import { showToast } from '../utils/toast';

const plans = [
    { id: 'startup', name: 'Startup (Grátis)' },
    { id: 'starter', name: 'Starter (R$49,99/mês)' },
    { id: 'advanced', name: 'Advanced (R$99,99/mês)' },
    { id: 'custom', name: 'Personalizado' }
];

function EditUserModal({ show, onClose, editingUser, onUserEdited }) {
    const [plan, setPlan] = useState('');
    const [maxTenants, setMaxTenants] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        // Popula o formulário com os dados do usuário a ser editado
        if (editingUser) {
            setPlan(editingUser.plan || 'startup');
            setMaxTenants(editingUser.maxTenants || 10);
        } else {
            // Limpa o formulário se não houver usuário (caso o modal feche)
            setPlan('');
            setMaxTenants('');
            setIsSubmitting(false);
        }
    }, [editingUser]);

    // Não renderiza nada se não for para mostrar ou se não houver usuário
    if (!editingUser) {
        return null;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const payload = {
            targetUid: editingUser.uid,
            newPlan: plan
        };

        if (plan === 'custom') {
            const tenantLimit = parseInt(maxTenants, 10);
            if (isNaN(tenantLimit) || tenantLimit <= 0) {
                showToast('warning', 'Para o plano Personalizado, forneça um limite de tenants que seja um número positivo.');
                setIsSubmitting(false);
                return;
            }
            payload.newMaxTenants = tenantLimit;
        }

        try {
            const functions = getFunctions();
            const editUser = httpsCallable(functions, 'edit_msp_user');
            await editUser(payload);

            showToast('success', 'O usuário foi atualizado com sucesso.');
            onUserEdited(); // Atualiza a lista na página de usuários
            onClose();      // Fecha o modal

        } catch (error) {
            showToast('error', `Não foi possível atualizar o usuário: ${error.message}`);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Editar Usuário</Modal.Title>
            </Modal.Header>
            <Form id="editUserForm" onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className="form-floating mb-3">
                        <input type="email" className="form-control" id="editingUserEmail" value={editingUser.contactEmail} placeholder="E-mail do Usuário" readOnly disabled />
                        <label htmlFor="editingUserEmail">E-mail do Usuário</label>
                    </div>
                    <div className="form-floating mb-3">
                        <select className="form-select" id="userPlan" value={plan} onChange={(e) => setPlan(e.target.value)} disabled={isSubmitting}>
                            {plans.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                        </select>
                        <label htmlFor="userPlan">Plano de Assinatura</label>
                    </div>

                    {plan === 'custom' && (
                        <div className="form-floating">
                            <input
                                type="number"
                                className="form-control"
                                id="maxTenants"
                                value={maxTenants}
                                onChange={(e) => setMaxTenants(e.target.value)}
                                placeholder="Nº de Tenants"
                                min="1"
                                required
                                disabled={isSubmitting}
                            />
                            <label htmlFor="maxTenants">Limite de Tenants</label>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
                        Cancelar
                    </Button>
                    <Button variant="primary" type="submit" form="editUserForm" disabled={isSubmitting}>
                        {isSubmitting ? 'Salvando...' : 'Salvar Alterações'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default EditUserModal;